import { FC } from 'react';
import { Grid, Title } from '@mantine/core';
import Subtitle from 'components/Subtitle';
import FieldText from './FieldText';
import FieldCheckbox from './FieldCheckbox';
import { useFormikContext } from 'formik';
import { RegistrationDto } from 'types/common';

const TableReservation: FC = () => {
    const { values } = useFormikContext<RegistrationDto>();

    return (
        <>
            <Subtitle title="Pöytäpaikka varaus" />
            <p> Yksi pistorasia ja yksi nettipistoke per pöytä. Muista oma jatkojohto ja nettipiuha mukaan! </p>
            <Title order={4}>
                Tuon mukana <span className="required">*</span>
            </Title>
            <Grid gutter="md">
                <Grid.Col span={12}>
                    <FieldCheckbox name="mukaanPc" label="pc pelikone/läppäri (+näyttö)" />
                </Grid.Col>
                <Grid.Col span={12}>
                    <FieldCheckbox name="mukaanKonsoli" label="konsoli (+näyttö)" />
                </Grid.Col>
                <Grid.Col span={12}>
                    <FieldCheckbox name="mukaanHengailu" label="tulen vain hengailemaan" />
                </Grid.Col>
                <Grid.Col span={2}>
                    <FieldCheckbox name="mukaanMuuta" label="Muuta: " />
                </Grid.Col>
                <Grid.Col span={10}>
                    <FieldText
                        name="mukaanMuutaKommentti"
                        title=""
                        placeholder="Muuta"
                        size="xs"
                        style={{ width: 250 }}
                        disabled={!values.mukaanMuuta}
                    />
                </Grid.Col>
            </Grid>
        </>
    );
};

export default TableReservation;
